import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { bonusConfigApi, type BonusConfig, type CreateBonusConfigPayload, type UpdateBonusConfigPayload } from "../lib/bonusConfigApi";

export function useBonusConfigs(businessId: string) {
  return useQuery({
    queryKey: ["bonusConfigs", businessId],
    queryFn: () => bonusConfigApi.list(businessId),
    enabled: !!businessId,
    select: (data) => data.items,
  });
}

export function useCreateBonusConfig(businessId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateBonusConfigPayload) => bonusConfigApi.create(businessId, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["bonusConfigs", businessId] }),
  });
}

export function useUpdateBonusConfig(businessId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ bonusId, payload }: { bonusId: string; payload: UpdateBonusConfigPayload }) =>
      bonusConfigApi.update(businessId, bonusId, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["bonusConfigs", businessId] }),
  });
}

export function useDeleteBonusConfig(businessId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (bonusId: string) => bonusConfigApi.delete(businessId, bonusId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["bonusConfigs", businessId] }),
  });
}

export type { BonusConfig };
